import { ChainId, chainSettings } from "@/constants/chain-specific";
import { DEX_LIST } from "../project-specific/farms/dex";
import type { AggregatorListType, ChainAggregatorsRecordType } from "./types";
import { RequiredAggregatorChainType } from "../project-specific/project";
import { Address } from "viem";

export const SHIB_AGGR: AggregatorListType = {
  yak: {
    address: "0x7fB900C14c9889A559C777Df0D5eF5f8A5b58bd0",
    maxHops: 3,
    minFee: 0.01,
    maxFee: 0.05,
    holderFeeSettings: {
      discountMultiplier: 0.5,
    },
    adapters: {
      "0xC729eD984b00F5E66Da2247C9B90c4CA0a784Eb3": {
        name: "ChewySwap",
        metadata: DEX_LIST.chewyswap,
      },
      "0x3BfC7BC06C5fA57b780c4a4e86e134F8aF4b1E7a": {
        name: "Marswap",
        metadata: DEX_LIST.marswap,
      },
      "0x1E27a51B7908cf0235512E507dCf5B3A74Fc0d80": {
        name: "ShibaSwap V1",
        metadata: DEX_LIST.shibaswapv1,
      },
      "0x3a9284Adebe62f68De079b55A04104c7DC01A3a3": {
        name: "ShibaSwap V2",
        metadata: DEX_LIST.shibaswapv2,
      },
      "0x1006Bee9175F669E40B40E1a9c4feAe16dbAec86": {
        name: "WoofSwap",
        metadata: DEX_LIST.woofswap,
      },
      "0xb9A583CF51d40BDFd06FB739AE53301F31aD68f2": {
        name: "WoofSwap Pro",
        metadata: DEX_LIST.woofswappro,
      },
      "0x37619Bf328bb5Df9E1a9Ae181ea87BDE82b889da": {
        name: "PunkSwap",
        metadata: DEX_LIST.punkswap,
      },
    },
  },
};

export const DOGE_AGGR: AggregatorListType = {
  yak: {
    address: "0x771037cf7CBb4F1dF79027b73E3DAC8bc95f80c6",
    maxHops: 3,
    minFee: 0.01,
    maxFee: 0.05,
    holderFeeSettings: {
      discountMultiplier: 0.5,
    },
    adapters: {
      "0x6b3AB9A21EbF4bc5d1885722CFf33EBC0605E156": {
        name: "ChewySwap",
        metadata: DEX_LIST.chewyswapdc,
      },
      "0xf7fb8A82E6DFbAc5A1C185D2fDA9025458cB3B81": {
        name: "FraxSwap",
        metadata: DEX_LIST.fraxswap,
      },
      "0xA1A914478fF6B9d30179DDe0Fe0e30e1885af7cc": {
        name: "YodeSwap",
        metadata: DEX_LIST.yodeswap,
      },
      "0xEFF7e7CCc008ed16dBDd07ce5F4bA6D7F6b622F1": {
        name: "QuickSwap V2",
        metadata: DEX_LIST.quickswapv2,
      },
      "0x3b2378a29F9CbDb1f20A72611C0f000aF05630cb": {
        name: "QuickSwap V3",
        metadata: DEX_LIST.quickswapv3,
      },
      "0xea219a790582459b52b70A1caea56EC4D11dC614": {
        name: "KibbleSwap",
        metadata: DEX_LIST.kibbleswap,
      },
      "0x09bE1785340Afad76410946709Aa6fB280dD2fc1": {
        name: "Wojak",
        metadata: DEX_LIST.wojak,
      },
      "0xD2E6E7f3b6cB3cA2b8b8b2E2E8D4C3F3F1F5F5F5": {
        name: "DogMoney",
        metadata: DEX_LIST.dogmoney,
      },
      "0x73D20fC8AE18E5D25424C436aECC960E1C2a96e7": {
        name: "DogeSwap",
        metadata: DEX_LIST.dogeswap,
      },
    },
  },
};

export const chainAggregators: ChainAggregatorsRecordType = {
  109: SHIB_AGGR.yak,
  2000: DOGE_AGGR.yak,
};

export const getDexByAdapterAddress = (
  adapterAddress: Address,
  chainId: RequiredAggregatorChainType
) => {
  const dex = chainAggregators?.[chainId]?.adapters?.[adapterAddress];
  return dex?.metadata;
};

export const getDexRouterByAdapterAddress = (
  adapterAddress: Address,
  chainId: RequiredAggregatorChainType
) => {
  const dex = getDexByAdapterAddress(adapterAddress, chainId);
  return dex?.router.address;
};

export const getDexFactoryByAdapterAddress = (
  adapterAddress: Address,
  chainId: RequiredAggregatorChainType
) => {
  const dex = getDexByAdapterAddress(adapterAddress, chainId);
  return dex?.factory.address;
};
